<template>
  <b-modal v-model="showModal" centered header-class="custom-modal-header" footer-class="custom-modal-footer">
    <template #modal-header>
      <p class="text-header">{{ title }}</p>
    </template>
    <b-form>
      <InputText
        v-model="form.value"
        textFloat="Value"
        placeholder="Value"
        name="value"
        isRequired
        :isValidate="$v.form.value.$error"
        :v="$v.form.value"
        type="text"
        class="mb-0"
      />
    </b-form>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button
          :disabled="isLoading"
          class="cancel-button"
          @click="onCloseModal()"
        >
          Cancel
        </button>
        <button :disabled="isLoading" class="save-button" @click="onSubmit()">
          Save
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ModalForm",
  components: {
    InputText
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
  },
  validations() {
    return {
      form: {
        value: { required }
      },
    };
  },
  data: function() {
    return {
      showModal: false,
      isLoading: false,
      form: {
        id: 0,
        value: "",
        name: "",
        type: "",
        userGUID: "",
        variableId: 0
      },
    };
  },
  methods: {
    onShowModal: async function(item = false) {
      this.$v.$reset();
      if (item) this.form = { ...item };
      else this.setDefaultData();

      this.showModal = true;
    },
    setDefaultData() {
      this.form = {
        id: 0,
        value: "",
        name: "",
        type: "",
        userGUID: "",
        variableId: 0
      };
    },
    onCloseModal() {
      this.showModal = false;
    },
    onSubmit: async function() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;

      await this.axios
        .post(`${this.$baseUrl}/Customer/${this.type}/save`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : data.message });
            this.$emit("reloadData");
          }
          else this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
        });
      this.isLoading = false;

      this.onCloseModal();
    },
  },
};
</script>
